module.exports = __webpack_public_path__ + "static/media/conf-app6.da2b77a7.png";